/* eslint-disable react/display-name */
import React from "react";
import { ColumnType } from "../ComparisonGridTypes";

var renderNumericCell = function renderNumericCell(cell) {
  var formattedNumber = cell.value.toLocaleString();
  return /*#__PURE__*/React.createElement(React.Fragment, null, formattedNumber);
};

export var getRenderer = function getRenderer() {
  var type = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : ColumnType.TEXT;

  if (type === ColumnType.NUMERIC) {
    return renderNumericCell;
  }

  return "Cell";
};
export var getCustomHeaderRenderer = function getCustomHeaderRenderer(renderHeader) {
  return function (_ref) {
    var column = _ref.column;
    var id = column.id;
    var columnRenderProps = {
      id: id
    };
    return renderHeader(columnRenderProps);
  };
};